import { render, staticRenderFns } from "./MenuMkDir.vue?vue&type=template&id=3b25ffe8&"
import script from "./MenuMkDir.vue?vue&type=script&lang=js&"
export * from "./MenuMkDir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports